import React, { useState } from 'react';
import BasicModal from '../shared/BasicModal';
import { MainLinkButton } from '../styled/buttons/MainLinkButton';
import { AUTH_ACTIONS } from '../../constants/actions';
import { useDispatch } from 'react-redux';
import { ExitIcon } from '../../modules/Icons';
import { Loader } from '../shared/Loader';
import { addNotification } from '../../state/actions/notificationsActions';
import ProfileUpdateSuccessNotification from '../accounts/ProfileUpdateSuccessNotification';
import { useRouter } from 'next/router';

const FreeSubscriptionConfirmation: React.FC<any> = ({ visible, setVisible, user }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [loading, setLoading] = useState(false);

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [error, setError] = useState(null);

  const renderNotificationErrorBody = (): React.ReactElement => {
    return (
      <>
        <span className="block font-normal text-white inter text-16 leading-24">
          You must accept the terms to subscribe to the Free Forever plan.
        </span>
      </>
    )
  }

  const handleSubmit = async () => {
    setError(null);

    if (!termsAccepted) {
      setError("You must accept the terms to subscribe to the Free Forever plan.")
      return false;
    }

    setLoading(true);
    dispatch({
      type: AUTH_ACTIONS.AUTH_UPDATE_PROFILE,
      sensitive: {
        free_subscriber: true,
        email_optin: true
      },
      headers: { authorization: user.token },
      onSuccess: () => {
        setLoading(false);
        router.push('/collections/free-vfx/category');
        dispatch({
          type: AUTH_ACTIONS.AUTH_SET_FREE_SUBSCRIBER_STATUS,
          freeSubscriberStatus: true,
        });
        dispatch(
          addNotification({
            body: <ProfileUpdateSuccessNotification />,
            customUi: true
          })
        );
      },
      onError: () => {
        setLoading(false);
      }
    });
  };

  return (
    <BasicModal
      visible={visible}
      setVisible={() => {
        setVisible(false);
      }}>
      <ExitIcon
        className="absolute top-6 right-10 md:top-4 md:right-4 cursor-pointer stroke-white w-[32px] h-[32px]"
        onClick={() => {
          setVisible(false);
        }}
      />

      {loading && <Loader />}

      <div className="text-white text-[24px] font-700 pl-8 md:pl-4">Start Your Free Forever Plan</div>
      <div className="w-screen max-w-[744px] p-8 md:p-4">
        <p className="pb-6 text-[18px] text-gray-400">
          You're about to subscribe to the <strong>Free Forever</strong> plan. Get access to exclusive ActionVFX benefits, including the ActionVFX Sampler Pack!
        </p>

        <p className="text-[20px] font-bold bg-gray-800 text-a-green text-center p-4 rounded-[5px]">
          This plan is 100% free. No credit card required.
        </p>

        <div className="flex items-start gap-2 my-5" cy-test-id="license-confirmation">
          <input
            id="licenseConfirm"
            className="mt-1"
            type="checkbox"
            onChange={(e) => {
              setTermsAccepted(e.target.checked);
            }}
          />
          <label htmlFor="licenseConfirm" className="text-gray-400 cursor-pointer text-14">
            I agree to receive marketing communications and the benefits of the Free Forever plan. I understand I can unsubscribe from emails at any time.
          </label>
        </div>
        {error &&
          <p className="bg-red-900 text-white rounded-[5px] p-3 text-12 my-6">{error}</p>
        }

        <div className="flex justify-end w-full gap-4">
          <MainLinkButton
            testId="submit-button"
            variant="disabled"
            size=""
            onClick={() => setVisible(false)}
            className="!cursor-pointer">
            Cancel
          </MainLinkButton>
          <MainLinkButton
            testId="submit-button"
            variant="green"
            size=""
            onClick={() => handleSubmit()}
            className="">
            Confirm
          </MainLinkButton>
        </div>
      </div>
    </BasicModal>
  );
};

export default FreeSubscriptionConfirmation;